import UserHomeComponent from './user-home-component';
import HomeColumn from '../home-column/home-column';

/***
 * The home page, containing links to each of the other pages.
 */
const userHome = angular
    .module('FacilityData.Home.UserHome', [
        HomeColumn
    ])
    .component('userHome', UserHomeComponent)
    .name;

export default userHome;


// WEBPACK FOOTER //
// ./app/components/home/user-home/user-home.js